<ngx-spinner
  type="ball-scale-multiple"
  name="main"
  size="medium"
  bdColor="rgba(0,0,0,0.2)">
  <span class="text-white">{{ 'COMPONENT.LOADER.LOADING' | translate }}</span>
</ngx-spinner>
